import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { productApi as api } from 'api/product';
import { DataTable, Notifications } from 'shared';

function ViewCohortCustomers() {
    const [rows, setRows] = useState([]);
    const [cohortOptions, setCohortOptions] = useState([]);
    const [selectedCohort, setSelectedCohort] = useState(null);
    const [includeRemoved, setIncludeRemoved] = useState(false);
    const [notification, setNotification] = useState({ text: null, level: null });

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'cohortID', Header: 'Cohort ID' },
        { accessor: 'customerID', Header: 'Customer ID' },
        { accessor: 'cohortName', Header: 'Cohort' },
        { accessor: 'insertedAt', Header: 'Inserted' },
        { accessor: 'removedAt', Header: 'Removed' },
    ];

    const getCohorts = async () => {
        const response = await api.getCohorts();
        if (response.status === false) {
            setNotification({
                text: `Could not load cohorts${response.msg ? `: ${response.msg}` : ''}`,
                level: 'error',
            });
            setCohortOptions([]);
            return;
        }

        setCohortOptions(response.data.rows ?? []);
    };

    const getCohortCustomers = async () => {
        if (!selectedCohort) {
            setRows([]);
            return;
        }

        const response = await api.getCohortCustomers(selectedCohort.id, includeRemoved);
        if (response.status === false) {
            setNotification({
                text: `Could not load cohort customers${response.msg ? `: ${response.msg}` : ''}`,
                level: 'error',
            });
            setRows([]);
            return;
        }

        setRows(response.data.rows ?? []);
    };

    useEffect(() => {
        getCohorts();
    }, []);

    useEffect(() => {
        getCohortCustomers();
    }, [selectedCohort, includeRemoved]);

    return (
        <div>
            <h1>Cohort customers</h1>
            <Notifications options={notification} />
            {}
            <Autocomplete
                options={cohortOptions}
                getOptionLabel={(c) => (c && c.name != null ? `${c.name} (ID ${c.id})` : '')}
                value={selectedCohort}
                onChange={(_e, newValue) => setSelectedCohort(newValue)}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search cohort by name or pick from list"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        placeholder="Type to filter…"
                    />
                )}
                renderOption={(c) => (
                    <div>
                        <strong>{c.name || `Cohort ${c.id}`}</strong>
                        <br />
                        <small>ID: {c.id}</small>
                    </div>
                )}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        color="primary"
                        checked={includeRemoved}
                        onChange={(e) => setIncludeRemoved(e.target.checked)}
                    />
                }
                label="Include removed customers (default is active customers only)"
            />
            <div>
                <DataTable columns={columns} data={rows} />
            </div>
        </div>
    );
}

export { ViewCohortCustomers };
